import React, { useState, useContext } from "react";
import { Link, NavLink, useParams, useNavigate } from "react-router-dom";
import { WebAssetsContext } from "../App";
import Swal from 'sweetalert2';
import { ToastContainer, toast, Zoom } from 'react-toastify';
const Useradd = (props) => {
  const WebAssets = useContext(WebAssetsContext);
  const api = WebAssets.apiURL;
  const navigate = useNavigate();
  const params = useParams();
  const [disabled, setDisabled] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [status, setStatus] = useState('0');
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [emailverify, setEmailverify] = useState("");
  const [is_mobile_verified, setis_mobile_verified] = useState("0");
  const [is_approved, setis_approved] = useState("0");

  const [uploadfileview, setUploadfileview] = useState(false);

  const errortoast = (text) => {
    toast.error(text,
      {
        autoClose: 3000,
        transition: Zoom,
        theme: "colored",
        closeOnClick: true,
        pauseOnHover: true,
      }
    );
  };

  const actvieStatus = () => {
    setStatus('1');
  }

  const inactvieStatus = () => {
    setStatus('0');
  }


  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(true);
    try {
      let res = await fetch(api + "addUser", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: name,
          email: email,
          password: password,
          phone: mobileNumber,
          address: address,
          city: city,
          status: status,
          emailverify: emailverify,
          is_mobile_verified: is_mobile_verified,
          is_approved: is_approved,
        }),
      });
      let output = await res.json();
      setDisabled(false);
      if (res.status === 200) {
        if (output.status === 2) {
          getvalidationErr(output.response);
        }
        if (output.status === true) {
          setName('');
          setEmail('');
          setPassword('');
          setMobileNumber('');
          setCity('');
          setAddress('');
          setDisabled(false);
          setEmailverify('');
          
          
          Swal.fire({
            title: 'Success',
            text: 'User added successfully!',
            icon: 'success'
          }).then((result) => {
            if (result.isConfirmed) {
              navigate("/admin/users");
            }
          });
        }

      }
    } catch (err) {
      setDisabled(false);
    }
  };

  const getvalidationErr = (errors) => {
    const errorsConvertInArry = Object.values(errors);
    let collectAllValidationErr = [];
    errorsConvertInArry.forEach((error, index) => {
      collectAllValidationErr.push(<div key={index}>{error}</div>);
    });
    const storeAllValidtionErr = (
      <>
        {collectAllValidationErr}
      </>
    );
    errortoast(storeAllValidtionErr);
  }

  return (
    <>
      <ToastContainer />
      <div className="section-body">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h4>Add Customer Information</h4>
                <div className="card-header-form">
                  <button onClick={() => navigate("/admin/users")} className="btn btn-icon icon-left btn-primary"><i className="fas fa-arrow-right"></i> Back</button>
                </div>
              </div>
              <div className="card-body p-4">

                <form onSubmit={handleSubmit} id="create-course-form">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>Name <small className="text-danger">*</small></label>
                        <input
                          type="text"
                          value={name}
                          placeholder="Name"
                          onChange={(e) => setName(e.target.value)}
                          className="form-control"
                        />

                      </div>

                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>Email<small className="text-danger">*</small></label>
                        <input
                          type="text"
                          value={email}
                          placeholder="Email"
                          onChange={(e) => setEmail(e.target.value)}
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>Password<small className="text-danger">*</small></label>
                        <input
                          type="text"
                          value={password}
                          placeholder="Password"
                          onChange={(e) => setPassword(e.target.value)}
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>Phone</label>
                        <input
                          type="text"
                          value={mobileNumber}
                          placeholder="Mobile Number"
                          onChange={(e) => setMobileNumber(e.target.value)}
                          className="form-control"
                        />
                      </div>
                    </div>



                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>City</label>
                        <input
                          type="text"
                          value={city}
                          placeholder="City"
                          onChange={(e) => setCity(e.target.value)}
                          className="form-control"
                        />

                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>Address</label>

                        <textarea
                          value={address}
                          placeholder="Address"
                          onChange={(e) => setAddress(e.target.value)}
                          className="form-control"
                        >

                        </textarea>



                      </div>
                    </div>
                    <div className="col-sm-6">
                    <div className="form-group">
                      <label>Email Verified</label>
                      <div className="row">
                        <div className="col-sm-3">
                          <input type="radio" id="statusEmailVerified" name="email_verify" className=""
                            value="1"
                            checked={emailverify === '1'}
                            onChange={() =>  setEmailverify('1')}

                          /> <label htmlFor="statusEmailVerified">Verfied</label>
                        </div>
                        <div className="col-sm-3">
                          <input type="radio" id="statusEmailunVerified" name="email_verify" className="custom-control-inpu"
                            value="0"
                            checked={emailverify === '0'}
                            onChange={() => setEmailverify('0')}
                          /> <label htmlFor="statusEmailunVerified">Unverified</label>
                        </div>
                      </div>
                      </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Mobile Number  Verified</label>
                      <div className="row">
                        <div className="col-sm-3">
                          <input type="radio" id="statusMobileVerified" name="phone_verify" className=""
                            value="1"
                            checked={is_mobile_verified === '1'}
                            onChange={() =>  setis_mobile_verified('1')}

                          /> <label htmlFor="statusMobileVerified">Verified</label>
                        </div>
                        <div className="col-sm-3">
                          <input type="radio" id="statusMobileunVerified" name="phone_verify" className="custom-control-inpu"
                            value="0"
                            checked={is_mobile_verified === '0'}
                            onChange={() => setis_mobile_verified('0')}
                          /> <label htmlFor="statusMobileunVerified">Unverified</label>
                        </div>
                      </div>
                      </div>
                  </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>Status</label>
                        <div className="row">
                          <div className="col-sm-3">
                            <input type="radio" id="statusActive" name="status" className=""
                              value="1"
                              checked={status === '1'}
                              onChange={actvieStatus}

                            /> <label htmlFor="statusActive">Active</label>
                          </div>
                          <div className="col-sm-3">
                            <input type="radio" id="statusInactive" name="status" className="custom-control-inpu"
                              value="0"
                              checked={status === '0'}
                              onChange={inactvieStatus}
                            /> <label htmlFor="statusInactive">Inactive</label>
                          </div>
                        </div>



                      </div>
                    </div>

                    <div className="col-12">
                      <div className="card-footer text-center">
                        <button className="btn btn-primary mr-1" type="submit" disabled={disabled}> {disabled == false ? 'Submit' : 'Submiting...'} </button>

                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>

  );
}

export default Useradd;
